import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';

// Grey strip under the header (design-system.md §3.5). items: [{ label, to?, state? }], last = current page.
const Breadcrumb = ({ items }) => (
    <Box as='nav' aria-label='Breadcrumb' bg='raano.band' px={{ base: '12px', md: '40px' }} py={{ base: '4px', md: '2px' }} >
        <Box as='ol' display='flex' flexWrap='wrap' alignItems='center' textStyle='breadcrumb' listStyleType='none' >
            {items.map((item, i) => {
                const last = i === items.length - 1;
                return (
                    <Box as='li' key={i} display='flex' alignItems='center' minWidth={0} >
                        {last
                            ? <Text as='span' aria-current='page' color='raano.black' noOfLines={1} >{item.label}</Text>
                            : <Text as={RouterLink} to={item.to} state={item.state} color='blackAlpha.600' _hover={{ color: 'raano.black' }} >{item.label}</Text>}
                        {!last && <Box as='span' mx={{ base: '6px', md: '10px' }} color='blackAlpha.500' fontSize='0.8em' >›</Box>}
                    </Box>
                );
            })}
        </Box>
    </Box>
);

export default Breadcrumb;
